module.exports = __webpack_public_path__ + "static/media/email.75b8bb49.svg";